import * as tslib_1 from "tslib";
import { CorrelationAction } from '@awp/core/ngrx';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["AUTHENTICATE"] = "[Data] Authenticate";
    ActionTypes["SIREN_RESPONSE"] = "[Data] Siren Response";
    ActionTypes["RESET_ALL_DATA"] = "[Data] Reset Response";
    ActionTypes["RESET_DATA"] = "[Data] Reset Data";
})(ActionTypes || (ActionTypes = {}));
var SirenResponseAction = /** @class */ (function () {
    function SirenResponseAction(payload) {
        this.payload = payload;
        this.type = ActionTypes.SIREN_RESPONSE;
    }
    return SirenResponseAction;
}());
export { SirenResponseAction };
var ResetAllDataAction = /** @class */ (function () {
    function ResetAllDataAction() {
        this.type = ActionTypes.RESET_ALL_DATA;
    }
    ResetAllDataAction.TYPE = ActionTypes.RESET_ALL_DATA;
    return ResetAllDataAction;
}());
export { ResetAllDataAction };
var AuthenticateAction = /** @class */ (function () {
    function AuthenticateAction() {
        this.type = ActionTypes.AUTHENTICATE;
    }
    return AuthenticateAction;
}());
export { AuthenticateAction };
var ResetDataAction = /** @class */ (function (_super) {
    tslib_1.__extends(ResetDataAction, _super);
    function ResetDataAction(id) {
        var _this = _super.call(this, id) || this;
        _this.type = ActionTypes.RESET_DATA;
        return _this;
    }
    ResetDataAction.TYPE = ActionTypes.RESET_DATA;
    return ResetDataAction;
}(CorrelationAction));
export { ResetDataAction };
